import {
  Component,
  PipeTransform,
  Pipe,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-pipe-error",
  templateUrl: "./pipe-error.html",
  styleUrls: ["./pipe-error.scss"],
})
export class PipeErrorComponent {
  items = [
    {
      NomedoGestor: "ZERO ",
      CNPJGestor: "05043746000104",
      TipoDeOperação: "",
      TipoDeLiquidação: "",
      NomeDoFundo: "",
      CNPJ: "",
      CódigoSAC: "",
      Banco: "",
      Agência: "",
      ContaCorrente: "",
      CódigoDoAtivo: "",
      FundoInvestido: "",
      FundoInterno: "",
      CNPJdoFundoInvestido: "",
      ClasseDoFundoInvestido: "",
      CódigoMnemonicoCetipDoFundo: "",
      TipoDeCotaDoCondomínio: "",
      PUdeEmissão: "",
      ValorDaCota: "",
      ContaCetipDoInvestidor: "",
      NomeContraparte: "",
      CnpjContraparte: "",
      ContaCetipContraparte: "",
      Quantidade: "",
      ValorDaOperação: "",
      ÉnovoFundoNoMercado: "",
    },
    {
      NomedoGestor: "ZERO",
      CNPJGestor: "05043746000104",
      TipoDeOperação: "",
      TipoDeLiquidação: "",
      NomeDoFundo: "",
      CNPJ: "",
      CódigoSAC: "",
      Banco: "",
      Agência: "",
      ContaCorrente: "",
      CódigoDoAtivo: "",
      FundoInvestido: "",
      FundoInterno: "",
      CNPJdoFundoInvestido: "",
      ClasseDoFundoInvestido: "",
      CódigoMnemonicoCetipDoFundo: "",
      TipoDeCotaDoCondomínio: "",
      PUdeEmissão: "",
      ValorDaCota: "",
      ContaCetipDoInvestidor: "",
      NomeContraparte: "",
      CnpjContraparte: "",
      ContaCetipContraparte: "",
      Quantidade: "",
      ValorDaOperação: "",
      ÉnovoFundoNoMercado: "",
    },
    {
      NomedoGestor: "ZERO",
      CNPJGestor: "05043746000104",
      TipoDeOperação: "",
      TipoDeLiquidação: "",
      NomeDoFundo: "",
      CNPJ: "",
      CódigoSAC: "",
      Banco: "",
      Agência: "",
      ContaCorrente: "",
      CódigoDoAtivo: "",
      FundoInvestido: "",
      FundoInterno: "",
      CNPJdoFundoInvestido: "",
      ClasseDoFundoInvestido: "",
      CódigoMnemonicoCetipDoFundo: "",
      TipoDeCotaDoCondomínio: "",
      PUdeEmissão: "",
      ValorDaCota: "",
      ContaCetipDoInvestidor: "",
      NomeContraparte: "",
      CnpjContraparte: "",
      ContaCetipContraparte: "",
      Quantidade: "",
      ValorDaOperação: "",
      ÉnovoFundoNoMercado: "",
    },
  ];
}
